<template>
  <rich-text :content="value" />
</template>

<script>
export default {
  name: "ControlRte",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>
